import { Card, Tag, Button } from "antd";
import { Star, MapPin, Heart, BarChart3 } from "lucide-react";
import "./CollegeBanner.css";
import { useFavourites } from "Features/Colleges/context/CollegeContext";
import { useUserInfo } from "GlobalStates/User";

export const CollegeBanner = ({ data }) => {
  const { favourites, addFavourite, removeFavourite } = useFavourites();
  const { user } = useUserInfo();

  if (!data) return null;

  const getLogoSrc = (logo) => {
    if (!logo) return null;
    return logo.startsWith("data:image/")
      ? logo
      : `data:image/png;base64,${logo}`;
  };

  const isFavourited = favourites?.some((college) => college.id === data.id);

  const handleSaveClick = () => {
    if (!data.id) {
      console.error("College ID is missing.");
      return;
    }

    if (isFavourited) {
      removeFavourite(data.id);
    } else {
      addFavourite(data.id);
    }
  };

  return (
    <Card className="college-banner-card">
      <div className="college-banner-content">
        <div className="college-header">
          <div className="college-info">
            <div className="college-logo">
              <img
                src={getLogoSrc(data.logo)}
                alt="College Logo"
                className="logo-image"
              />
            </div>
            <div className="college-details">
              <h1>{data.Name}</h1>
              <div className="location">
                <span>
                  <MapPin className="location-icon" />
                </span>
                <span>{data.City}</span>
              </div>
              <div className="tags-container">
                {data.Tags?.map((tag, index) => (
                  <Tag key={index} className="college-tag">
                    {tag}
                  </Tag>
                ))}
              </div>
            </div>
          </div>
          <div className="college-actions">
            {user?.isPremiumUser && (
              <Button
                className="action-button"
                aria-label="Save college to favorites"
                onClick={handleSaveClick}
              >
                <Heart
                  className="action-icon"
                  color={isFavourited ? "red" : "gray"}
                  fill={isFavourited ? "red" : "none"}
                />
                <span className="action-text">
                  {isFavourited ? "Saved" : "Save"}
                </span>
              </Button>
            )}

            <Button className="action-button" aria-label="Compare college">
              <BarChart3 className="action-icon" />
              <span className="action-text">Compare</span>
            </Button>
          </div>
        </div>

        <div className="rating-container">
          <div className="rating-stars">
            {[...Array(5)].map((_, index) => (
              <Star
                key={index}
                className="rating-star"
                fill={
                  index < Math.floor(data.Rating) ||
                  (index === Math.floor(data.Rating) && data.Rating % 1 >= 0.5)
                    ? "#facc15"
                    : "none"
                }
                stroke="#facc15"
              />
            ))}
            <span className="rating-value">{data.Rating}</span>
          </div>
        </div>

        <div className="stats-container" style={{ backgroundColor: "white" }}>
          <div className="stat-item">
            <p className="stat-label" style={{ color: "#6b7280" }}>
              Avg. Tuition
            </p>
            <p className="stat-value" style={{ fontSize: "1rem" }}>
              {data.Average_Tuition_fees}
            </p>
          </div>
          <div className="stat-item">
            <p className="stat-label" style={{ color: "#6b7280" }}>
              Acceptance Rate
            </p>
            <p className="stat-value">{data.Acceptance_Rate}</p>
          </div>
          <div className="stat-item">
            <p className="stat-label" style={{ color: "#6b7280" }}>
              Application Deadline
            </p>
            <p className="stat-value" style={{ fontSize: "1rem" }}>
              {"Fall :"}
              {data.Application_Deadline.Fall}
            </p>
            <p className="stat-value" style={{ fontSize: "1rem" }}>
              {"Spring :"}
              {data.Application_Deadline.Spring}
            </p>
          </div>
          <div className="stat-item">
            <p className="stat-label" style={{ color: "#6b7280" }}>
              Total Programs
            </p>
            <p className="stat-value">{data.Total_Programs}</p>
          </div>
        </div>
      </div>
    </Card>
  );
};
